export default __webpack_public_path__ + "static/helveticaNeue-3354ee4792605d407c43838bd5b8dbaf.woff";